import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6259410f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "nav" }
const _hoisted_2 = { class: "nav-container" }
const _hoisted_3 = { class: "nav-app-name" }
const _hoisted_4 = { class: "nav-items-close" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "app-name" }, "FitTrackee", -1))
const _hoisted_6 = {
  key: 0,
  class: "nav-items-group"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nav-item nav-separator" }, null, -1))
const _hoisted_8 = { class: "nav-items-user-menu" }
const _hoisted_9 = {
  key: 0,
  class: "nav-items-group"
}
const _hoisted_10 = { class: "nav-item nav-profile-img" }
const _hoisted_11 = {
  key: 1,
  class: "nav-items-group"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-language" }, null, -1))

import { ComputedRef, computed, ref, capitalize } from 'vue'
  import { useI18n } from 'vue-i18n'

  import UserPicture from '@/components/User/UserPicture.vue'
  import { AUTH_USER_STORE, ROOT_STORE } from '@/store/constants'
  import { IDropdownOption } from '@/types/forms'
  import { IUserProfile } from '@/types/user'
  import { useStore } from '@/use/useStore'
  import { availableLanguages } from '@/utils/locales'

  
export default /*#__PURE__*/_defineComponent({
  emits: ['menuInteraction'],
  setup(__props, { emit }) {

  

  const { locale } = useI18n()
  const store = useStore()

  const authUser: ComputedRef<IUserProfile> = computed(
    () => store.getters[AUTH_USER_STORE.GETTERS.AUTH_USER_PROFILE]
  )
  const isAuthenticated: ComputedRef<boolean> = computed(
    () => store.getters[AUTH_USER_STORE.GETTERS.IS_AUTHENTICATED]
  )
  const language: ComputedRef<string> = computed(
    () => store.getters[ROOT_STORE.GETTERS.LANGUAGE]
  )
  let isMenuOpen = ref(false)

  function openMenu() {
    isMenuOpen.value = true
    emit('menuInteraction', true)
  }
  function closeMenu() {
    isMenuOpen.value = false
    emit('menuInteraction', false)
  }
  function updateLanguage(option: IDropdownOption) {
    locale.value = option.value.toString()
    store.commit(ROOT_STORE.MUTATIONS.UPDATE_LANG, option.value)
  }
  function logout() {
    store.dispatch(AUTH_USER_STORE.ACTIONS.LOGOUT)
  }

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "nav-item app-name",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/')))
        }, " FitTrackee ")
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["nav-icon-open", { 'menu-open': _unref(isMenuOpen) }])
      }, [
        _createElementVNode("i", {
          class: "fa fa-bars hamburger-icon",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (openMenu()))
        })
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["nav-items", { 'menu-open': _unref(isMenuOpen) }])
      }, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("i", {
            class: _normalizeClass(["fa fa-close close-icon nav-item", { 'menu-closed': !_unref(isMenuOpen) }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (closeMenu()))
          }, null, 2)
        ]),
        _createElementVNode("div", {
          class: "nav-items-app-menu",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (closeMenu()))
        }, [
          (_unref(isAuthenticated))
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_router_link, {
                  class: "nav-item",
                  to: "/"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('dashboard.DASHBOARD')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  class: "nav-item",
                  to: "/workouts"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(capitalize(_ctx.$t('workouts.WORKOUT', 2))), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  class: "nav-item",
                  to: "/statistics"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('statistics.STATISTICS')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  class: "nav-item",
                  to: "/workouts/add"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('workouts.ADD_WORKOUT')), 1)
                  ]),
                  _: 1
                }),
                (_unref(isAuthenticated) && _unref(authUser).admin)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      class: "nav-item",
                      to: "/admin"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('admin.ADMIN')), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _hoisted_7
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_unref(isAuthenticated))
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(UserPicture, { user: _unref(authUser) }, null, 8, ["user"])
                ]),
                _createVNode(_component_router_link, {
                  class: "nav-item",
                  to: "/profile",
                  onClick: closeMenu
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(authUser).username), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", {
                  class: "nav-item nav-link",
                  onClick: logout
                }, _toDisplayString(_ctx.$t('user.LOGOUT')), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_component_router_link, {
                  class: "nav-item",
                  to: "/login",
                  onClick: closeMenu
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('user.LOGIN')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  class: "nav-item",
                  to: "/register",
                  onClick: closeMenu
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('user.REGISTER')), 1)
                  ]),
                  _: 1
                })
              ])),
          (_unref(availableLanguages) && _unref(language))
            ? (_openBlock(), _createBlock(_component_Dropdown, {
                key: 2,
                class: "nav-item",
                options: _unref(availableLanguages),
                selected: _unref(language),
                onSelected: updateLanguage
              }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              }, 8, ["options", "selected"]))
            : _createCommentVNode("", true)
        ])
      ], 2)
    ])
  ]))
}
}

})